export default {"src":"/_next/static/media/house_40.25bb69a8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};